import React, { useEffect, useState } from "react";
import './App.css';
import {
  SearchController, 
  publicHttpClient, 
  ISearchResponse, 
  ISearchQuery, 
  ICompanySearch,
  IProductLocation,
  ILocation,
  IPreferenceProgram,
  selectContext,
  IProductItem,
  IIPCountry
} from 'madeinusacomponentlibrary'
import configData from './AppConfig.json'
import "madeinusacomponentlibrary/dist/index.css"
import { APIClient } from "./Data/APIClient";
import { styled } from "@mui/styles";
import { Backdrop, CircularProgress } from "@mui/material";

function App() {
  const [, setSearchQuery] = useState<ISearchQuery>();
  const [fetching, setFetching] = useState(false);
  const [searchResultOutput, setSearchResultOutput] = useState<ISearchResponse>();
  const [states, setStates] = useState(
    [] as IProductLocation[]
  );
  const CustomBackdrop = styled(Backdrop)({
    zIndex: 1,
    color: "#fff",
  });
  const [countries, setCountries] = useState(
    [] as ILocation[]
  );
  const [regions, setRegions] = useState(
    [] as ILocation[]
  );
  const [preferencePrograms, setPreferencePrograms] = useState(
    [] as IPreferenceProgram[]
  );
  const [productSelections, setProductSelections] = useState(
    [] as IProductItem[]
  );
  const [userCountry, setUserCountry] = useState(
    {} as IIPCountry
  );
  const httpClient = new publicHttpClient(configData); 
  const apiClient = new APIClient();

  useEffect(() => {
    (async () => {
      apiClient.getCurrentCountry().then(country => {setUserCountry(country)});
      const states1 = apiClient.getStates();
      const countries1 = apiClient.getCountries();
      const prefProg = apiClient.getPreferencePrograms();
      const regions1 = apiClient.getRegions();
      const prods =apiClient.getProducts();
      const [s,c,p,r,pr] = await Promise.all([states1,countries1,prefProg,regions1,prods]);
      setStates(s);
      setCountries(c);
      setPreferencePrograms(p);
      setRegions(r);
      setProductSelections(pr);
    })();
  },[]);
  
  const callSearch = async (searchQuery:ISearchQuery)  => {
    setFetching(true);
    setSearchQuery(searchQuery)
    let data = await httpClient.searchCompanies(searchQuery);
    setSearchResultOutput(data)
    setFetching(false);
  }
  
  const exportExcel = async (searchQuery:ISearchQuery)  => {
    setFetching(true);
    await httpClient.downloadExcel(searchQuery);
    setFetching(false);
  }

  const exportPdf = async (searchQuery:ISearchQuery)  => {
    setFetching(true);
    await httpClient.downloadPdf(searchQuery);
    setFetching(false);
  }

  const saveSelectedResultItem = async (companySearch:ICompanySearch)  => {
    await httpClient.LogSelectedResult(companySearch);
  }

  return (
    <selectContext.Provider
      value={{ countries, states, regions, preferencePrograms, productSelections, userCountry }}
    >
      <div className="App">
        <CustomBackdrop open={fetching}>
          <CircularProgress color="inherit" aria-label="Loading" />
        </CustomBackdrop>
        <div className="container">
        <p>&nbsp;</p>
        <p>&nbsp;</p>
            <img src="logo.svg" alt="logo" style={{margin: "10px 10px"}} />
          <div style={{display:"flex",alignItems:"center"}}>
          </div>
        
      </div>
        <SearchController 
          onSearch={callSearch} 
          onExportExcelRequest={exportExcel}
          onExportPdfRequest={exportPdf}
          onResultItemSelect={saveSelectedResultItem} 
          resultsPageSize={configData.searchResultsPageSize}
          searchResponse={searchResultOutput} />
    </div>
    </selectContext.Provider>)
}

export default App;
